module.exports = __webpack_public_path__ + "img/refundstatus.eff79bd3.svg";